export function resetDateCarousel(flow = 'default', index=0) {
    switch (flow) {
        case 'date next loan car':
            return {
                index: index,
                steps: [
                    {slug: 'date', active: true},
                    {slug: 'loan-car', active: true},
                    {slug: 'submissions', active: false}
                ]
            }
        case 'date next no loan car':
            return {
                index: index,
                steps: [
                    {slug: 'date', active: true},
                    {slug: 'submissions', active: true}
                ]
            }
        default:
            return {
                index: index,
                steps: [
                    {slug: 'date', active: true},
                    {slug: 'loan-car', active: false},
                    {slug: 'submissions', active: false}
                ]
            }
    }
}
